import {
    COMPANY_GETONE_FAIL,
    COMPANY_GETONE_SUCCESS,
    COMPANY_UPSERT_FAIL,
    COMPANY_UPSERT_SUCCESS
  } from "../actions/types";
  
  const company = JSON.parse(localStorage.getItem("Company"));
  
  const initialState = company ? { company: company } : { company: null };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case COMPANY_GETONE_SUCCESS:
        return {
          ...state, company : payload.company,
        };
      case COMPANY_UPSERT_SUCCESS:
        return { ...state, company : payload }
      default:
        return state;
    }
  }